import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import React from "react";
import { X } from "lucide-react";
import styles from "../../_css/ContenetManagement.module.css";

const DeleteVideoModal = ({ show, onHide, onDelete }) => {
    return (
        <Modal
            show={show}
            onHide={onHide}
            backdrop="static"
            keyboard={false}
            dialogClassName="modal-37"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Body>
                <div className={styles.deleteVideoModalContainer}>
                    {/* Close Icon */}
                    <X
                        onClick={onHide}
                        className={styles.deleteVideoModalCloseIcon}
                        size={24}
                    />

                    {/* Header with Image and Title */}
                    <div className={styles.deleteVideoModalHeader}>
                        <img
                            className={styles.deleteVideoModalImage}
                            src={`${process.env.PUBLIC_URL}/img/delete-icon.png`}
                            alt="Delete Icon"
                        />
                        <h1 className={styles.deleteVideoModalTitle}>Delete Video?</h1>
                    </div>

                    {/* Buttons in same line */}
                    <div className={styles.deleteVideoModalButtonContainer}>
                        <button
                            className={styles.deleteVideoModalBackButton}
                            onClick={() => onHide()}
                        >
                            Back
                        </button>
                        <button
                            className={styles.deleteVideoModalDeleteButton}
                            onClick={() => {
                                onDelete();
                            }}
                        >
                            Remove Video
                        </button>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default DeleteVideoModal;